// extracted by mini-css-extract-plugin
export default {"page":"c_-z","cartModal":"d_-z","checkout":"e_-z","placeholder":"f_-z","account":"g_-z"};